const init = ()=> {
    
    const  cardFloatToggle = `js-card-float-toggle`;

    if($(`.${cardFloatToggle}`).length > 0){
        
        $(`.${cardFloatToggle}`).on('click', ()=>{
            console.log('click');
            const parent = $(`.${cardFloatToggle}`).closest(`.card-float`);

            parent.toggleClass(`card-float--active`)
        })
    }
	
}

export const cardFloat = {
	init: init
};